<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-6">
<h2 class="top">List of Maps</h2>
<p class="toc">Southeastern Louisiana </p>
<p class="toc">The Mississippi River Valley </p>
<p class="toc">Siege of New Madrid and Island No. 10 </p>
<p class="toc">Western Tennessee </p>
<p class="toc"> Forts Jackson and Saint Philip </p>
<p class="toc">The Bayou Teche Region of Southern Louisiana </p>
<p class="toc">The Mississippi Delta </p>
<p class="toc">The Red River Campaign </p>
<p class="toc_c">Photos and illustrations have been placed throughout the text for the convenience of the reader.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_List_of_Maps.vue?1a50b1fe